// extracted by mini-css-extract-plugin
module.exports = {"login-page":"styles_login-page__1VWCl","content":"styles_content__36BAW","body":"styles_body__3EkfO"};